function getDisplayName(Component) {
  return Component.displayName || Component.name || "Component";
}
export {
  getDisplayName as default
};
//# sourceMappingURL=getDisplayName.js.map
